import React from 'react';

export type PricingType = 'subscription' | 'per-interview';

interface PricingTypeToggleProps {
  activeType: PricingType;
  onTypeChange: (type: PricingType) => void;
  className?: string;
}

export const PricingTypeToggle: React.FC<PricingTypeToggleProps> = ({
  activeType,
  onTypeChange,
  className = ''
}) => {
  return (
    <div className={`flex justify-center mb-8 ${className}`}>
      <div className="inline-flex bg-surface-light/50 dark:bg-surface-dark/50 backdrop-blur-md rounded-lg p-1 border border-border-light dark:border-border-dark">
        <button
          onClick={() => onTypeChange('per-interview')}
          className={`px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
            activeType === 'per-interview'
              ? 'bg-primary-light dark:bg-primary-dark text-white shadow-md'
              : 'text-text-secondary-light dark:text-text-secondary-dark hover:text-text-primary-light dark:hover:text-text-primary-dark'
          }`}
        >
          Per Interview
        </button>
        <button
          onClick={() => onTypeChange('subscription')}
          className={`px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
            activeType === 'subscription'
              ? 'bg-primary-light dark:bg-primary-dark text-white shadow-md'
              : 'text-text-secondary-light dark:text-text-secondary-dark hover:text-text-primary-light dark:hover:text-text-primary-dark'
          }`}
        >
          Subscription
        </button>
      </div>
    </div>
  );
};
